import PostDetailComponent from '@components/post-detail';
import * as React from 'react';

export interface IPostPageProps {}

export default function PostPage(props: IPostPageProps) {
  return <PostDetailComponent />;
}
